import { createFileRoute, redirect } from '@tanstack/react-router'
import { ROUTES } from '_/constants/routes'

export const Route = createFileRoute('/_authenticated/settings/')({
	beforeLoad: () => {
		throw redirect({ to: ROUTES.settings.general })
	},
})
